import type { Contact } from '@payaca/types/contactTypes';
import type { Deal, DealAddressType } from '@payaca/types/dealTypes';
import type { ListedDealsListViewPage } from '@payaca/types/listedDealTypes';
import type { Address } from '@payaca/types/locationTypes';
import type { FetchedEntity } from '@payaca/types/storeTypes';
import type { DeclareAsyncAction } from '../types';
export interface State {
  deals: { [key: number]: FetchedEntity<Deal> };

  isGettingListedDealsPage: boolean;
  listedDealsPage: ListedDealsListViewPage | null;

  isAddingDealAddress: boolean;
  isDealAddressAddedSuccessfully?: boolean;

  isRemovingDealAddress: boolean;
  isDealAddressRemovedSuccessfully?: boolean;
}

export enum ActionType {
  REQUEST_GET_DEAL = 'deals.requestGetDeal',
  GET_DEAL_SUCCESS = 'deals.getDealSuccess',
  GET_DEAL_FAILURE = 'deals.getDealFailure',
  CLEAR_DEALS = 'deals.clearDeals',

  REQUEST_ACTIVATE_DEAL_VIEW = 'deals.requestActivateDealView',
  ACTIVATE_DEAL_VIEW_SUCCESS = 'deals.activateDealViewSuccess',
  ACTIVATE_DEAL_VIEW_FAILURE = 'deals.activateDealViewFailure',

  REQUEST_CREATE_DEAL = 'deals.requestCreateDeal',
  CREATE_DEAL_SUCCESS = 'deals.createDealSuccess',
  CREATE_DEAL_FAILURE = 'deals.createDealFailure',

  REQUEST_UPDATE_DEAL = 'deals.requestUpdateDeal',
  UPDATE_DEAL_SUCCESS = 'deals.updateDealSuccess',
  UPDATE_DEAL_FAILURE = 'deals.updateDealFailure',

  REQUEST_GET_LISTED_DEALS_PAGE = 'deals.requestGetListedDealsPage',
  GET_LISTED_DEALS_PAGE_SUCCESS = 'deals.getListedDealsPageSuccess',
  GET_LISTED_DEALS_PAGE_FAILURE = 'deals.getListedDealsPageFailure',
  CLEAR_LISTED_DEALS_PAGE = 'deals.clearListedDealsPage',

  REQUEST_ADD_DEAL_ADDRESS = 'deals.requestAddDealAddress',
  ADD_DEAL_ADDRESS_SUCCESS = 'deals.addDealAddressSuccess',
  ADD_DEAL_ADDRESS_FAILURE = 'deals.addDealAddressFailure',

  REQUEST_REMOVE_DEAL_ADDRESS = 'deals.requestRemoveDealAddress',
  REMOVE_DEAL_ADDRESS_SUCCESS = 'deals.removeDealAddressSuccess',
  REMOVE_DEAL_ADDRESS_FAILURE = 'deals.removeDealAddressFailure',

  GET_DEAL_ACCEPTED_ITEMS_COPY_REQUEST = 'deals.getDealAcceptedItemsCopy:request',
}

export interface AddDealAddressRequestData {
  dealId: number;
  dealAddressType: DealAddressType;
  address: Address;
  addAddressToDealCustomer?: boolean;
  contacts: Contact[];
}

export interface SagaConfig {
  apiBaseurl: string;
  getAuthHeader: () => Promise<string>;
  isNativeApp: boolean;
}

export type GetDealAcceptedItemsCopy = DeclareAsyncAction<
  ActionType,
  {
    request: {
      type: ActionType.GET_DEAL_ACCEPTED_ITEMS_COPY_REQUEST;
      payload: {
        dealId: number;
        callback?: (acceptedItemsCopy: string) => void;
      };
    };
  }
>;
